import { Action, Reducer, ActionCreator, combineReducers } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { RootState } from '..';
import { IEciImplantSelfTestingState } from '../../interfaces/states/IEciImplantSelfTestingState';
import { IErrors } from '../../common/model/errors.model';

export enum Type {
  SET_SPINNERUPLOADSELFTESTINGAPPFORM = '@@eciImplantSelfTesting/SET_SPINNERUPLOADSELFTESTINGAPPFORM',
  SET_ERRORS = '@@eciImplantSelfTesting/SET_ERRORS',
}

const initialState: IEciImplantSelfTestingState = {
  errors: {},
  uploadSelfTestingFileSpinner: false
};

// Actions

export type Actions = SetSpinnerUploadSelfTestingAppFormAction | SetErrorsAction;

export interface SetSpinnerUploadSelfTestingAppFormAction extends Action<Type.SET_SPINNERUPLOADSELFTESTINGAPPFORM> {
  showSpinner: boolean;
}

export interface SetErrorsAction extends Action<Type.SET_ERRORS> {
  errors: IErrors;
}

export const setSpinnerUploadSelfTestingAppForm: ActionCreator<SetSpinnerUploadSelfTestingAppFormAction> = (showSpinner: boolean) => ({
  type: Type.SET_SPINNERUPLOADSELFTESTINGAPPFORM,
  showSpinner: showSpinner
});

export const setErrors: ActionCreator<SetErrorsAction> = (errors: IErrors) => ({
  type: Type.SET_ERRORS,
  errors: errors
});

export const setErrorsInState: ActionCreator<ThunkAction<void, RootState, unknown, Actions>> = (
  errors: IErrors
) => (
  async (dispatch) => {
    dispatch(setErrors(errors));
  }
);

export const spinnerUploadSelfTestingAppForm: ActionCreator<ThunkAction<void, RootState, unknown, Actions>> = (
  showSpinner: boolean
) => (
  async (dispatch) => {
    dispatch(setSpinnerUploadSelfTestingAppForm(showSpinner));
  }
);

// Reducers

const errors: Reducer<IErrors> = (state = initialState.errors, action) => {
  switch (action.type) {
    case Type.SET_ERRORS:
      return (action as SetErrorsAction).errors;
    default:
      return state;
  }
};

const uploadSelfTestingFileSpinner: Reducer<boolean> = (state = initialState.uploadSelfTestingFileSpinner, action) => {
  switch (action.type) {
    case Type.SET_SPINNERUPLOADSELFTESTINGAPPFORM:
      return (action as SetSpinnerUploadSelfTestingAppFormAction).showSpinner;
    default:
      return state;
  }
};

export const eciImplantSelfTestingStore = combineReducers({
  errors,
  uploadSelfTestingFileSpinner
});
